import React, { useState, useEffect, useRef } from 'react';
import { Header } from '../../components/Header';
import { Load } from '../../components/Load';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { Form, Button, Col, Row } from 'react-bootstrap';
import { FormGroup } from '../../components/FormGroup';
import { Label } from '../../components/Label';
import { Options, Select } from '../../components/Select';
import InputMask from 'react-input-mask';
import AlertMessage from '../../components/Alert';
import api from '../../services/api';
import './style.css';

export function TrabalhadoresCadastrar() {

    const [isLoading, setIsLoading] = useState(true);
    const [name, setName] = useState('');
    const [cpf, setCpf] = useState('');
    const [rg, setRg] = useState('');
    const [data_nascimento, setDataNascimento] = useState('');
    const [sexo, setSexo] = useState('');
    const [email, setEmail] = useState('');
    const [celular, setCelular] = useState('');
    const [senha, setSenha] = useState("");
    const [confirmarSenha, setConfirmarSenha] = useState("");

    // UseRef para todos os campos relevantes
    const refNome: any = useRef(null);
    const refCpf: any = useRef(null);
    const refRg: any = useRef(null);
    const refDataNascimento: any = useRef(null);
    const refSexo: any = useRef(null);
    const refEmail: any = useRef(null);
    const refCelular: any = useRef(null);
    const refSenha: any = useRef(null);
    const refConfirmarSenha: any = useRef(null);

    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });

    const [isNomeInvalido, setIsNomeInvalido] = useState(false);
    const [isCpfInvalido, setIsCpfInvalido] = useState(false);
    const [isSexoInvalido, setIsSexoInvalido] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    });

    const handleSubmit = async (event: any) => {
        event.preventDefault();

        const payload = {
            nome: name,
            cpf,
            rg,
            data_nascimento,
            sexo,
            email,
            celular,
            senha,
        };
        let isValid = true;

        if (!name) {
            setAlert({ message: 'Por favor, preencha o campo nome', variant: 'danger', show: true });
            setIsNomeInvalido(true);
            refNome.current.focus();
            isValid = false;
        } else {
            setIsNomeInvalido(false);
        }

        if (!cpf) {
            setAlert({ message: 'Por favor, preencha o campo CPF.', variant: 'danger', show: true });
            setIsCpfInvalido(true);
            isValid = false;
        } else {
            setIsCpfInvalido(false);
        }

        if (!sexo) {
            setAlert({ message: 'Por favor, selecione o campo sexo.', variant: 'danger', show: true });
            setIsSexoInvalido(true);
            isValid = false;
        } else {
            setIsSexoInvalido(false);
        }

        if (!senha) {
            setAlert({ message: 'Por favor, preencha o campo senha.', variant: 'danger', show: true });
            refSenha.current.focus();
            isValid = false;
        }

        if (!confirmarSenha) {
            setAlert({ message: 'Por favor, confirme a senha.', variant: 'danger', show: true });
            refConfirmarSenha.current.focus();
            isValid = false;
        }

        if (senha && confirmarSenha && senha !== confirmarSenha) {
            setAlert({ message: 'As senhas não coincidem.', variant: 'danger', show: true });
            refConfirmarSenha.current.focus();
            isValid = false;
        }

        if (!isValid) return;

        try {
            const response = await api.post('/trabalhadores/cadastro', payload);
            if (response.data && response.data.message) {
                setAlert({ message: response.data.message, variant: 'danger', show: true });
                return;
            }
            setAlert({ message: 'Trabalhador cadastrado', variant: 'success', show: true });
            refNome.current.focus();
            setName('');
            setCpf('');
            setRg('');
            setDataNascimento('');
            setSexo('');
            setEmail('');
            setCelular('');
            setSenha('');
            setConfirmarSenha('');

        } catch (error) {
            console.error('Erro ao enviar dados do formulário:', error);
            setAlert({ message: 'Erro ao enviar os dados do formulário.', variant: 'danger', show: true });
        }
    };

    const handleSelectSexo = (id: any, e: any) => {
        setSexo(id);
    };

    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='../../' />
            <Main>
                <Form onSubmit={handleSubmit}>
                    <h3>Informações Pessoais</h3>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Nome *' htmlFor="nome" />
                                <input
                                    type="text"
                                    id="nome"
                                    placeholder="Digite o Nome"
                                    value={name}
                                    onChange={(e) => {
                                        setName(e.target.value);
                                        if (e.target.value) {
                                            setIsNomeInvalido(false);
                                        }
                                    }}
                                    className={isNomeInvalido ? 'invalid' : ''}
                                    style={{ width: '100%' }}
                                    ref={refNome}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='CPF *' htmlFor="cpf" />
                                <InputMask
                                    mask="999.999.999-99"
                                    id='cpf'
                                    value={cpf}
                                    onChange={(e: any) => setCpf(e.target.value)}
                                    className={isCpfInvalido ? 'invalid-field' : ''}
                                    placeholder="Digite o CPF"
                                    style={{ width: '100%' }}
                                    ref={refCpf}
                                />
                            </FormGroup>
                        </Col>

                    </Row>

                    <Row className='my-4'>
                        {/* Data de Nascimento */}
                        <Col xs={12} md={4} xl={4}>
                            <FormGroup>
                                <Label title='Data de Nascimento' htmlFor="dataNascimento" />
                                <input
                                    type="date"
                                    id="dataNascimento"
                                    value={data_nascimento}
                                    onChange={(e) => setDataNascimento(e.target.value)}
                                    style={{ width: '100%' }}
                                    ref={refDataNascimento}
                                />
                            </FormGroup>
                        </Col>

                        <Col xs={12} md={4} xl={4}>
                            <FormGroup>
                                <Label title='RG' htmlFor="rg" />
                                <InputMask
                                    mask="99.999.999-9"
                                    value={rg}
                                    onChange={(e: any) => setRg(e.target.value)}
                                    placeholder="Digite o RG"
                                    className="form-control"
                                    style={{ width: '100%' }}
                                    ref={refRg}
                                />
                            </FormGroup>
                        </Col>

                        {/* Sexo */}
                        <Col xs={12} md={4} xl={4}>
                            <FormGroup>
                                <Label title='Sexo *' htmlFor="sexo" />
                                <Select width="600px" id='empresas' onSelect={handleSelectSexo}
                                    className={isSexoInvalido ? 'invalid-field' : ''}
                                    ref={refSexo}
                                >
                                    <Options key='M' value='M' name='Masculino' />
                                    <Options key='F' value='F' name='Feminino' />
                                </Select>
                            </FormGroup>
                        </Col>

                    </Row>
                    <Row>
                        {/* Email */}
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Email' htmlFor="email" />
                                <input
                                    type="text"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    style={{ width: '100%' }}
                                    placeholder='example@example.com'
                                    ref={refEmail}
                                />
                            </FormGroup>
                        </Col>

                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Celular' htmlFor="celular" />
                                <InputMask
                                    mask="(99) 99999-9999"
                                    value={celular}
                                    onChange={(e: any) => setCelular(e.target.value)}
                                    placeholder="(__) _____-____"
                                    style={{ width: '100%' }}
                                    ref={refCelular}
                                />
                            </FormGroup>
                        </Col>

                    </Row>
                    <Row>
                        <Col xs={12} md={6}>
                            <FormGroup>
                                <Label title='Senha' htmlFor="senha" />
                                <InputMask
                                    ref={refSenha}
                                    type="password"
                                    id="senha"
                                    placeholder="Digite a Senha"
                                    value={senha}
                                    style={{ width: '100%' }}
                                    onChange={(e: any) => setSenha(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6}>
                            <FormGroup>
                                <Label title='Confirmar Senha' htmlFor="confirmar_senha" />
                                <InputMask
                                    ref={refConfirmarSenha}
                                    type="password"
                                    id="confirmarSenha"
                                    placeholder="Digite a Senha Novamente"
                                    value={confirmarSenha}
                                    style={{ width: '100%' }}
                                    onChange={(e: any) => setConfirmarSenha(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Button className="btn-main mt-4" type="submit">Inserir Trabalhador</Button>
                </Form>
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div>
    );
}
